(function () {
  const ROOT_SEL = '.kgh-header-mega';
  const NAVLIST_SEL = '.kgh-mega-nav__list';
  const ITEM_SEL = '.kgh-header-mega .kgh-mega-nav__item.has-mega';

  function init() {
    const rootWrap = document.querySelector(ROOT_SEL);
    if (!rootWrap) return;

    // zabráň double bind (Shopify editor reloady)
    if (rootWrap.dataset.kghBound === '1') return;
    rootWrap.dataset.kghBound = '1';

    const navList = rootWrap.querySelector(NAVLIST_SEL);
    const items = Array.from(rootWrap.querySelectorAll(ITEM_SEL));
    if (!navList || !items.length) return;

    // READY: až po frame (stabilnejší layout/hit-test)
    requestAnimationFrame(() => {
      document.documentElement.classList.add('kgh-header-mega-ready');
    });

    // ===== TOP offset pre fixed dropdown (ponechané, ale vypnuté) =====
    const setMegaTop = () => {
      const sticky = document.querySelector('sticky-header');
      const header = sticky ? sticky : document.querySelector('.section-header, .header-wrapper, header');
      if (!header) return;
      const rect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--kgh-mega-top', `${Math.max(0, rect.bottom)}px`);
    };
    // setMegaTop();
    // requestAnimationFrame(setMegaTop);
    // setTimeout(setMegaTop, 50);
    // setTimeout(setMegaTop, 250);
    // window.addEventListener('resize', setMegaTop, { passive: true });
    // window.addEventListener('scroll', setMegaTop, { passive: true });

    // ===== helpers =====
    let activeItem = null;
    let closeTimer = null;

    const clearCloseTimer = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const closeAll = () => {
      clearCloseTimer();
      items.forEach((it) => it.classList.remove('is-open'));
      document.documentElement.classList.remove('kgh-mega-open');
      activeItem = null;
    };

    // =========================
    // FETCH + VARIANT IMAGE LOGIC
    // =========================

    const fetchCache = new Map();        // url -> HTML
    const productJsonCache = new Map();  // handle -> product.js JSON
    const variantImgCache = new Map();   // `${handle}|||${variantIdOrValue}` -> url or ''

    const getParamFromUrl = (url, key) => {
      try {
        const u = new URL(url, window.location.origin);
        return u.searchParams.get(key);
      } catch (_) {
        return null;
      }
    };

    const getHandleFromCard = (cardEl) => {
      const h = cardEl.getAttribute('data-kgh-handle');
      if (h) return h;

      const href = cardEl.getAttribute('href') || '';
      const m = href.match(/\/products\/([^/?#]+)/i);
      return m ? m[1] : null;
    };

    const getVariantIdFromCardHref = (cardEl) => {
      const href = cardEl.getAttribute('href') || '';
      try {
        const u = new URL(href, window.location.origin);
        const v = u.searchParams.get('variant');
        return v ? String(v) : null;
      } catch (_) {
        const m = href.match(/[?&]variant=(\d+)/i);
        return m ? String(m[1]) : null;
      }
    };

    const pickVariantImageUrl = (variant) => {
      if (!variant) return null;

      if (variant.featured_image && typeof variant.featured_image === 'object' && variant.featured_image.src) {
        return variant.featured_image.src;
      }
      if (typeof variant.featured_image === 'string') {
        return variant.featured_image;
      }
      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        return variant.featured_media.preview_image.src;
      }
      return null;
    };

    const norm = (s) => String(s || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const findVariantByColorValue = (productJson, colorValue) => {
      if (!productJson || !colorValue) return null;

      const opts = Array.isArray(productJson.options) ? productJson.options : [];
      const idx = opts.findIndex(o => {
        const n = String(o.name || '').toLowerCase().trim();
        return n === 'farba' || n === 'color' || n === 'colour';
      });
      if (idx < 0) return null;

      const prop = `option${idx + 1}`;
      const target = norm(colorValue);

      const variants = Array.isArray(productJson.variants) ? productJson.variants : [];
      return variants.find(v => norm(v[prop]) === target) || null;
    };

    const forceImgToUrl = (imgEl, url) => {
      if (!imgEl || !url) return;

      imgEl.src = url;
      imgEl.removeAttribute('srcset');
      imgEl.removeAttribute('sizes');
      imgEl.setAttribute('loading', 'lazy');
    };

    const swapVariantImagesForPanel = async (panelEl, fetchUrl) => {
      if (!panelEl || !fetchUrl) return;

      const colorValue = getParamFromUrl(fetchUrl, 'filter.v.option.farba');

      const cards = Array.from(panelEl.querySelectorAll('.kgh-card'));
      if (!cards.length) return;

      await Promise.all(cards.map(async (card) => {
        const handle = getHandleFromCard(card);
        if (!handle) return;

        const imgEl = card.querySelector('img.kgh-card__img, img');
        if (!imgEl) return;

        const variantId = getVariantIdFromCardHref(card);
        const cacheKey = `${handle}|||${variantId || colorValue || 'no-key'}`;

        if (variantImgCache.has(cacheKey)) {
          const cached = variantImgCache.get(cacheKey);
          if (cached) forceImgToUrl(imgEl, cached);
          return;
        }

        try {
          let pj = productJsonCache.get(handle);
          if (!pj) {
            const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
            if (!res.ok) throw new Error(`product.js failed ${res.status}`);
            pj = await res.json();
            productJsonCache.set(handle, pj);
          }

          let chosenVariant = null;

          if (variantId) {
            const variants = Array.isArray(pj.variants) ? pj.variants : [];
            chosenVariant = variants.find(v => String(v.id) === String(variantId)) || null;
          }

          if (!chosenVariant && colorValue) {
            chosenVariant = findVariantByColorValue(pj, colorValue);
          }

          const variantImgUrl = pickVariantImageUrl(chosenVariant);

          if (variantImgUrl) {
            forceImgToUrl(imgEl, variantImgUrl);
          }

          variantImgCache.set(cacheKey, variantImgUrl || '');
        } catch (err) {
          variantImgCache.set(cacheKey, '');
          console.warn('[KGH Mega] variant image swap error', err);
        }
      }));
    };

    const loadFilteredProductsIntoPanel = async (panelEl) => {
      if (!panelEl) return;
      const url = panelEl.getAttribute('data-kgh-fetch-url');
      if (!url) return;

      if (panelEl.dataset.kghLoaded === '1') return;

      const grid = panelEl.querySelector('[data-kgh-grid]');
      const loading = panelEl.querySelector('[data-kgh-loading]');
      if (!grid) return;

      try {
        if (loading) loading.textContent = 'Načítavam…';

        if (fetchCache.has(url)) {
          grid.innerHTML = fetchCache.get(url);
          panelEl.dataset.kghLoaded = '1';
          await swapVariantImagesForPanel(panelEl, url);
          return;
        }

        const sep = url.includes('?') ? '&' : '?';
        const fetchUrl = `${url}${sep}section_id=kgh-mega-fetch`;

        const res = await fetch(fetchUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const fetched = doc.querySelector('[data-kgh-mega-fetch]');
        const cardsHtml = fetched ? fetched.innerHTML : '';

        const finalHtml = cardsHtml && cardsHtml.trim().length
          ? cardsHtml
          : `<p style="margin:0;">Žiadne produkty pre tento filter.</p>`;

        fetchCache.set(url, finalHtml);
        grid.innerHTML = finalHtml;
        panelEl.dataset.kghLoaded = '1';

        // warm cache product.js pre všetky karty
        const cards = Array.from(grid.querySelectorAll('.kgh-card'));
        const prefetches = cards.map((card) => {
          const handle = getHandleFromCard(card);
          if (!handle) return Promise.resolve();
          if (productJsonCache.has(handle)) return Promise.resolve();

          return fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
            .then(r => (r.ok ? r.json() : null))
            .then(j => { if (j) productJsonCache.set(handle, j); })
            .catch(() => {});
        });

        await Promise.allSettled(prefetches);

        await swapVariantImagesForPanel(panelEl, url);
      } catch (err) {
        if (loading) loading.textContent = 'Nepodarilo sa načítať produkty.';
        console.warn('[KGH Mega] filtered fetch error', err);
      }
    };

    // ===== setActive =====
    const setActive = (dropdown, key, l2KeyMaybe) => {
      dropdown.querySelectorAll('[data-kgh-panel]').forEach(p => p.classList.remove('is-active'));

      const panels = dropdown.querySelectorAll('[data-kgh-panel]');
      panels.forEach(p => p.classList.toggle('is-active', p.dataset.kghPanel === key));

      const l2Buttons = dropdown.querySelectorAll('[data-kgh-l2]');
      l2Buttons.forEach(btn => {
        btn.setAttribute('aria-selected', btn.dataset.kghL2 === l2KeyMaybe ? 'true' : 'false');
      });

      const subLists = dropdown.querySelectorAll('[data-kgh-subcats]');
      subLists.forEach(ul => ul.classList.toggle('is-active', ul.dataset.kghSubcats === l2KeyMaybe));

      const l3Links = dropdown.querySelectorAll('[data-kgh-l3]');
      l3Links.forEach(a => a.classList.toggle('is-active', a.dataset.kghTarget === key));

      const activePanel = dropdown.querySelector('[data-kgh-panel].is-active');
      if (activePanel && activePanel.hasAttribute('data-kgh-fetch-url')) {
        loadFilteredProductsIntoPanel(activePanel);
      }
    };

    const openItem = (item) => {
      if (!item || window.innerWidth < 750) return;

      clearCloseTimer();

      if (activeItem && activeItem !== item) activeItem.classList.remove('is-open');
      item.classList.add('is-open');
      document.documentElement.classList.add('kgh-mega-open');
      activeItem = item;

      const dd = item.querySelector('.kgh-mega');
      if (!dd) return;

      const defaultKey = dd.dataset.kghDefaultKey;
      const defaultL2 = dd.dataset.kghDefaultL2;
      if (defaultKey) setActive(dd, defaultKey, defaultL2);
    };

    const scheduleClose = () => {
      clearCloseTimer();
      closeTimer = setTimeout(closeAll, 300);
    };

    // =========================
    // HOVER "PO KRAJOCH": vyber najbližší L1 item podľa X,
    // keď si na bielej lište mimo textu
    // =========================
    const getClosestItemByX = (clientX) => {
      let best = null;
      let bestDist = Infinity;

      items.forEach((it) => {
        const r = it.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const d = Math.abs(clientX - cx);
        if (d < bestDist) {
          bestDist = d;
          best = it;
        }
      });

      return best;
    };

    let rafMove = null;

    // ===== drž otvorené kým hoveruješ lištu alebo dropdown =====
    navList.addEventListener('pointerenter', (e) => {
      if (window.innerWidth < 750) return;

      // Ak sme vošli do prázdneho miesta lišty, otvor najbližší item podľa X
      if (!e.target.closest('.kgh-mega-nav__item.has-mega')) {
        const closest = getClosestItemByX(e.clientX);
        if (closest) openItem(closest);
      } else if (activeItem) {
        openItem(activeItem);
      }
    });

    // Plynulé prepínanie podľa X pri pohybe po prázdnom mieste lišty
    navList.addEventListener('pointermove', (e) => {
      if (window.innerWidth < 750) return;
      if (e.target.closest('.kgh-mega-nav__item.has-mega')) return;

      if (rafMove) cancelAnimationFrame(rafMove);
      rafMove = requestAnimationFrame(() => {
        const closest = getClosestItemByX(e.clientX);
        if (closest && closest !== activeItem) openItem(closest);
      });
    }, { passive: true });

    // IMPORTANT: nezatváraj, ak ide pointer z lišty rovno do dropdownu
    navList.addEventListener('pointerleave', (e) => {
      if (window.innerWidth < 750) return;

      const toEl = e.relatedTarget;
      if (toEl && toEl.closest && toEl.closest('.kgh-mega')) return;

      scheduleClose();
    });

    // ===== L1 items =====
    items.forEach((item) => {
      const dd = item.querySelector('.kgh-mega');
      if (!dd) return;

      item.addEventListener('pointerenter', () => openItem(item));

item.addEventListener('focusin', (e) => {
  if (window.innerWidth < 750) return;
  if (e.target.closest('.kgh-mega')) return;
  openItem(item);
});

      dd.addEventListener('pointerenter', clearCloseTimer);

      // IMPORTANT: nezatváraj, ak ide pointer z dropdownu späť na lištu
      dd.addEventListener('pointerleave', (e) => {
        if (window.innerWidth < 750) return;

        const toEl = e.relatedTarget;
        if (toEl && toEl.closest && toEl.closest(NAVLIST_SEL)) return;

        scheduleClose();
      });

      dd.querySelectorAll('.kgh-mega__cat').forEach((btn) => {
        const onEnter = () => {
          if (window.innerWidth < 750) return;

          // Priame linky: nič neprepínaj
          if (btn.classList.contains('kgh-direct-link')) return;

          const key = btn.dataset.kghTarget;
          const l2Key = btn.dataset.kghL2;
          const defaultL3 = btn.dataset.kghDefaultL3;
          setActive(dd, defaultL3 || key, l2Key);
        };
        btn.addEventListener('pointerenter', onEnter);
        btn.addEventListener('focus', onEnter);
      });

      dd.querySelectorAll('[data-kgh-l3]').forEach((a) => {
        const onEnter = () => {
          if (window.innerWidth < 750) return;

          const targetKey = a.dataset.kghTarget;
          const targetPanel = dd.querySelector(`[data-kgh-panel="${CSS.escape(targetKey)}"]`);
          if (targetPanel && targetPanel.hasAttribute('data-kgh-fetch-url')) {
            loadFilteredProductsIntoPanel(targetPanel);
          }

          setActive(dd, targetKey, a.dataset.kghParentL2);
        };
        a.addEventListener('pointerenter', onEnter);
        a.addEventListener('focus', onEnter);
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest(ROOT_SEL)) closeAll();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < 750) closeAll();
    });
  }

  const initAndShow = () => {
    try {
      init();
    } finally {
      document.documentElement.classList.remove('kgh-mm-loading');
    }
  };

  // init ASAP
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAndShow);
  } else {
    initAndShow();
  }

  // Shopify editor re-init
  document.addEventListener('shopify:section:load', initAndShow);
  document.addEventListener('shopify:section:reorder', initAndShow);
})();
